{
  "projectId": "sms-payway-khm-web-app",
  "name": "sms-payway-khm-web-app",
  "version": "1.0.0.63",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --base-href /dev/pay/ --deploy-url /dev/pay/ --output-path=dist/pay --output-hashing=all && node scripts/postbuild-font-display.mjs dist/pay",
    "build-mpay": "ng build --base-href __ENV__/pay/ --deploy-url __ENV__/pay/ --aot --output-hashing=all && node scripts/postbuild-font-display.mjs dist",
    "customBuildCommand": "npm run runNpmInstall",
    "runNpmInstall": "npm install --legacy-peer-deps --include=optional",
    "watch": "ng build --watch --configuration development",
    "test": "cross-env NO_COLOR=1 ng test template-project --watch=false",
    "test:ci": "cross-env NO_COLOR=1 ng test template-project --watch=false",
    "test:watch": "ng test template-project --watch",
    "test:visual": "playwright test",
    "test:visual:update": "playwright test --update-snapshots",
    "test:visual:report": "playwright show-report",
    "gen:api": "ng-openapi-gen --input src/swagger-input.yml --output src/swagger-codegen/",
    "gen:lock": "rm -rf node_modules package-lock.json && npm install --package-lock-only --legacy-peer-deps --include=optional --os=linux --cpu=x64 --libc=glibc"
  },
  "private": true,
  "packageManager": "npm@10.8.2",
  "dependencies": {
    "@angular/animations": "^21.2.6",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.6",
    "@angular/compiler": "^21.2.6",
    "@angular/core": "^21.2.6",
    "@angular/forms": "^21.2.6",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.6",
    "@angular/platform-browser-dynamic": "^21.2.6",
    "@angular/router": "^21.2.6",
    "@cds/ng-core": "^21.0.9",
    "@cds/ng-themes": "^21.0.9",
    "@cds/ng-web-components": "^21.0.9",
    "@tailwindcss/postcss": "^4.3.3",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.5.1",
    "@analogjs/vitest-angular": "^2.5.1",
    "@angular-devkit/build-angular": "^21.2.4",
    "@angular/cli": "~21.2.4",
    "@angular/compiler-cli": "^21.2.6",
    "@playwright/test": "^1.49.1",
    "@vitest/coverage-v8": "^4.1.6",
    "autoprefixer": "^10.4.14",
    "cross-env": "^10.1.0",
    "jsdom": "^29.1.1",
    "msw": "^2.14.6",
    "postcss": "^8.5.18",
    "tailwindcss": "^4.0.12",
    "typescript": "~5.9.3",
    "vitest": "^4.1.6"
  },
  "optionalDependencies": {
    "@rollup/rollup-darwin-arm64": "^4.61.1",
    "@rollup/rollup-darwin-x64": "^4.61.1",
    "@rollup/rollup-linux-x64-gnu": "^4.61.1",
    "@rollup/rollup-linux-x64-musl": "^4.61.1",
    "@rollup/rollup-win32-x64-msvc": "^4.61.1",
    "@tailwindcss/oxide-darwin-arm64": "^4.3.0",
    "@tailwindcss/oxide-darwin-x64": "^4.3.0",
    "@tailwindcss/oxide-linux-x64-gnu": "^4.3.0",
    "@tailwindcss/oxide-linux-x64-musl": "^4.3.0",
    "@tailwindcss/oxide-win32-x64-msvc": "^4.3.0",
    "lightningcss-darwin-arm64": "^1.32.0",
    "lightningcss-darwin-x64": "^1.32.0",
    "lightningcss-linux-x64-gnu": "^1.32.0",
    "lightningcss-linux-x64-musl": "^1.32.0",
    "lightningcss-win32-x64-msvc": "^1.32.0"
  }
}
